export const generateAddingScheduleId = () => {
  return 999999999 + Math.floor(Math.random() * 10000);
};
